// pages/admin/StoriesList.jsx
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { deleteStory, fetchStoriesByTopic } from "../../utils/api";


export default function StoriesList() {
  const { topicId } = useParams();
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadStories = async () => {
    const data = await fetchStoriesByTopic(topicId);
    setStories(data);
    setLoading(false);
  };

  useEffect(() => {
    loadStories();
  }, [topicId]);

  const handleDelete = async (id) => {
    if (!confirm("Delete this story?")) return;
    await deleteStory(id);
    loadStories();
  };

  return (
    <div className="users-page">
      <div className="page-header">
        <h1 className="page-title">Stories</h1>
        <Link to={`/stories/${topicId}/new`} className="action-btn activate">
          + Add Story
        </Link>
      </div>

      <div className="table-wrapper">
        <table className="users-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Content</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr><td colSpan="3" className="empty">Loading…</td></tr>
            ) : stories.length === 0 ? (
              <tr><td colSpan="3" className="empty">No stories</td></tr>
            ) : (
              stories.map((s, i) => (
                <tr key={s.id}>
                  <td>{i + 1}</td>
                  <td>{s.title}</td>
                  <td dir="rtl">
                    <div dangerouslySetInnerHTML={{ __html: s.content }} />
                  </td>
                  <td className="flex gap-2">
                    <Link
                      to={`/stories/edit/${s.id}`}
                      className="action-btn activate"
                    >
                      Edit
                    </Link>
                    <button
                      className="action-btn deactivate"
                      onClick={() => handleDelete(s.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
